// Replace numeric counters with dot pagination on mobile
document.addEventListener('DOMContentLoaded', function() {
  function createDotPagination() {
    if (window.innerWidth > 990) return; // Only on mobile/tablet
    
    // Find all slider containers with counter
    const sliderContainers = document.querySelectorAll('.slider-buttons');
    
    sliderContainers.forEach(container => {
      // Skip if already processed
      if (container.querySelector('.custom-dots-pagination')) {
        return;
      }
      
      // Find the counter
      const counter = container.querySelector('.slider-counter.caption');
      if (!counter) return;
      
    // Find the slider (prefer aria-controls -> exact target)
    let slider = null;
    let slideCount = 0;

    // 1) Prefer aria-controls (most reliable)
    const nextBtn = container.querySelector('[aria-controls]');
    if (nextBtn) {
      const sliderId = nextBtn.getAttribute('aria-controls');
      if (sliderId) {
        slider = document.getElementById(sliderId);
      }
    }

    // 2) Fallback: search within parent slider-component
    if (!slider) {
      const parentContainer = container.closest('slider-component') || container.parentElement;
      if (parentContainer) {
        slider = parentContainer.querySelector('.multicolumn-list, .slider, ul[role="list"]');
      }
    }
      
      if (!slider) return;
      
    // Count ONLY direct slide items to avoid nested <li> in richtext
    const getDirectSlides = (root) => {
      // Prefer specific classes per slider type
      if (root.classList.contains('multicolumn-list')) {
        return Array.from(root.children).filter(el => el.classList && el.classList.contains('multicolumn-list__item'));
      }
      if (root.classList.contains('slider')) {
        return Array.from(root.children).filter(el => el.classList && el.classList.contains('slider__slide'));
      }
      if (root.classList.contains('slideshow')) {
        return Array.from(root.children).filter(el => el.classList && el.classList.contains('slideshow__slide'));
      }
      // Generic: direct LI children only
      return Array.from(root.children).filter(el => el.tagName === 'LI');
    };

    const slides = getDirectSlides(slider);
    slideCount = slides.length;
      
      // Do NOT trust counter total; it may include clones/virtual slides
      
      if (slideCount <= 1) return;
      
      console.log('Creating dots for slider with', slideCount, 'slides'); // Debug
      
      // Create dots container
      const dotsContainer = document.createElement('div');
      dotsContainer.className = 'custom-dots-pagination';
      
      // Create dots equal to direct slides count
      for (let i = 0; i < slideCount; i++) {
        const dot = document.createElement('button');
        dot.className = 'custom-dot';
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.setAttribute('data-slide-index', i);
        
        if (i === 0) {
          dot.classList.add('active');
        }
        
        // Add click handler
        dot.addEventListener('click', function() {
          const slideIndex = parseInt(this.getAttribute('data-slide-index'));
          
          // Update active dot
          dotsContainer.querySelectorAll('.custom-dot').forEach((d, index) => {
            d.classList.toggle('active', index === slideIndex);
          });
          
          // Try native Shopify slider-component navigation if present
          const sliderComponent = slider.closest('slider-component');
          if (sliderComponent && typeof sliderComponent.setActiveSlide === 'function') {
            sliderComponent.setActiveSlide(slideIndex);
          } else if (slider.scrollTo) {
            // Fallback: scroll by computed slide width
            const slidesLocal = Array.from(slider.children);
            const target = slidesLocal[slideIndex];
            if (target) {
              slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
            }
          }
          
          // Update counter text
          const currentSpan = counter.querySelector('.slider-counter--current');
          if (currentSpan) {
            currentSpan.textContent = slideIndex + 1;
          }
          
          // Counter update will be handled by observer below
        });
        
        dotsContainer.appendChild(dot);
      }
      
      // Insert dots after the counter
      counter.parentNode.insertBefore(dotsContainer, counter.nextSibling);
      
      // Listen for slider changes to update active dot
      const currentSpan = counter.querySelector('.slider-counter--current');
      if (currentSpan) {
        const observer = new MutationObserver(function() {
          const currentIndex = parseInt(currentSpan.textContent) - 1;
          dotsContainer.querySelectorAll('.custom-dot').forEach((dot, index) => {
            dot.classList.toggle('active', index === currentIndex);
          });
        });
        
        observer.observe(currentSpan, { childList: true, subtree: true });
      }
    });
  }
  
  // Initialize with delay to ensure DOM is fully loaded
  setTimeout(createDotPagination, 500);
  
  // Reinitialize on window resize
  window.addEventListener('resize', function() {
    setTimeout(createDotPagination, 100);
  });
  
  // Reinitialize when new content is loaded (for AJAX)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        setTimeout(createDotPagination, 200);
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
